<template>
  <div class="smsmain ">
        <div class="horizFlex">
           
            <div class="framed">
                <sendsmsframe ref="smstemplates"/>
            </div>
                
        </div>
        <div class="horizFlex">
                   
            <smstemplateadmin @refresh="refresh"  />
            <smshistory />
        </div>

  </div>
</template>

<script>
import sendsmsframe from './sendsmsframe.vue'
import smstemplateadmin from './smstemplateadmin.vue'
import smshistory from './smshistory.vue'

export default {
    name:'smsmessages',
    components:{
      sendsmsframe,
        smstemplateadmin,
        smshistory,
    },
    props:{
       
    },
    mixins:[],
    data(){
        return{
            pleaseWaitText:'Please wait...',
            pleaseWait:false,
            message:'',
         
        }
    },
    
    computed:{
      
        
    },
    methods:{
       refresh(){
        this.$refs.smstemplates.getTemplates()
       }
    
    }
}
</script>

<style>

.smsmain{
    display:flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

</style>

